import * as React from 'react';
import Svg, { Defs, LinearGradient, Path, Stop, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = (props: SvgProps) => (
    <Svg width={16} height={16} fill="none" {...props}>
        <Path
            fill="url(#a)"
            d="M13.188 6.46c.42.63.42 1.45 0 2.08L10.215 13H8.11l3.621-5.43a.126.126 0 0 0 0-.14L8.111 2h2.104l2.973 4.46Z"
        />
        <Path
            fill="url(#b)"
            d="M7.577 6.46c.42.63.42 1.45 0 2.08L4.604 13H2.5l3.621-5.43a.126.126 0 0 0 0-.14L2.5 2h2.104l2.973 4.46Z"
        />
        <Defs>
            <LinearGradient id="a" x1={2.5} x2={89.001} y1={7.5} y2={7.5} gradientUnits="userSpaceOnUse">
                <Stop stopColor={ds.colorValue.icon.brand} />
                <Stop offset={0.505} stopColor={ds.colorValue.background.pickType.surge.strong} />
                <Stop offset={1} stopColor={ds.colorValue.text.accent.yellow} />
            </LinearGradient>
            <LinearGradient id="b" x1={3} x2={88} y1={7.5} y2={7.5} gradientUnits="userSpaceOnUse">
                <Stop stopColor={ds.colorValue.icon.brand} />
                <Stop offset={0.505} stopColor={ds.colorValue.background.pickType.surge.strong} />
                <Stop offset={1} stopColor={ds.colorValue.text.accent.yellow} />
            </LinearGradient>
        </Defs>
    </Svg>
);
export { SvgComponent as GradientDoubleArrow };
